import { render, staticRenderFns } from "./AudienceSection.vue?vue&type=template&id=aff9a654&scoped=true"
import script from "./AudienceSection.vue?vue&type=script&lang=js"
export * from "./AudienceSection.vue?vue&type=script&lang=js"
import style0 from "./AudienceSection.vue?vue&type=style&index=0&id=aff9a654&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aff9a654",
  null
  
)

export default component.exports